import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';

import Suggestion from './Suggestion';
import SuggestionPaper from 'bento-ordering/locations/ui_components/SuggestionPaper';

// see https://material-ui.com/customization/z-index/ for zindex information for mui

const Suggestions = ({
  loading,
  suggestions,
  hasNoResults,
  getSuggestionItemProps
}) => {
  return (
    <Box position="relative">
      <Box
        position="absolute"
        left="0"
        right="0"
        top="0"
        bottom="0"
        zIndex="mobileStepper"
      >
        {(!!suggestions.length || loading || hasNoResults) && (
          <SuggestionPaper>
            <List>
              {suggestions.map((suggestion, idx, arr) => (
                <Suggestion
                  dataTestId={`autocomplete-suggestion-${idx}`}
                  key={suggestion.id}
                  {...getSuggestionItemProps(suggestion)}
                  {...suggestion}
                  isLast={idx === arr.length - 1}
                />
              ))}
            </List>
          </SuggestionPaper>
        )}
      </Box>
    </Box>
  );
};

Suggestions.defaultProps = {
  loading: false,
  suggestions: [],
  hasNoResults: false
};

Suggestions.propTypes = {
  getSuggestionItemProps: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  suggestions: PropTypes.array,
  hasNoResults: PropTypes.bool
};

export default Suggestions;
